const admin = "cmsAdmin";
const user = "cmsUser";

module.exports = {
  admin,
  user,
  // An account on a freezer scanner (planning/orderpicking-bouwplan-cms.md, besluit 25). It exists
  // only in the VCE project, may read rounds and write pick events, and must never get into the CMS.
  picker: "picker",
  // The roles that may use this CMS at all.
  CMS_ROLES: [admin, user],
};
